import e from "@dialpad/dialtone-tokens/layered/themes/tokens-storm-colors.css?inline";
//#region themes/storm.js
var t = {
	brand: {
		css: e,
		name: "storm"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
